<div class="hx-standard-tabs__bar" [class.hx-standard-tabs__bar--compact]="compact()">
  @for (tab of tabs(); track trackByIndex($index)) {
    <button
      type="button"
      class="hx-standard-tabs__btn"
      [class.hx-standard-tabs__btn--active]="activeTab() === tab.index"
      [class.hx-standard-tabs__btn--compact]="compact()"
      [attr.role]="'tab'"
      [attr.aria-selected]="activeTab() === tab.index"
      [attr.aria-label]="tab.label"
      (click)="onTabClick(tab.index)">
      @if (tab.icon) {
        <hx-icon [svgIcon]="tab.icon" class="hx-standard-tabs__icon"></hx-icon>
      }
      <span>{{ tab.label }}</span>
    </button>
  }
</div>
